import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  InitialStateType,
  ExperimentTypesType,
  AATestMetricType,
  SetAATestMatricFormPayloadType,
  AATestMetricResultType,
  AATestLoadingOverlayStateType,
} from 'features/ABAdmin/@types/ExperimentAddEdit'
import { v4 as uuidv4 } from 'uuid'

export const SLICE_NAME_AB_ADMIN_ADD_EDIT = 'abAdminAddEdit'

const initialState: InitialStateType = {
  isLoading: false,
  experimentType: 'LOGIN',
  isAATestEnabled: false,
  aaTest: {
    metrics: [],
    loadingOverlayState: 'CLOSED',
    metricResults: [],
  },
}

const slice = createSlice({
  name: SLICE_NAME_AB_ADMIN_ADD_EDIT,
  initialState,
  reducers: {
    resetState: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setExperimentType: (state, { payload }: PayloadAction<ExperimentTypesType>) => {
      state.experimentType = payload
    },
    setAATestEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.isAATestEnabled = payload
    },
    setAATestMetrics: (state, { payload }: PayloadAction<AATestMetricType[]>) => {
      state.aaTest.metrics = payload.map((metric) => ({
        ...metric,
        key: uuidv4(),
        thresholdValue: '',
        isChecked: false,
      }))
    },
    setAATestMetricForm: (state, { payload }: PayloadAction<SetAATestMatricFormPayloadType>) => {
      const selectedMatricIndex = state.aaTest.metrics.findIndex(({ key }) => key === payload.key)

      if (selectedMatricIndex >= 0) {
        state.aaTest.metrics[selectedMatricIndex][payload.field] = payload.value as never
      }
    },
    setAATestLoadingOverlayState: (
      state,
      { payload }: PayloadAction<AATestLoadingOverlayStateType>,
    ) => {
      state.aaTest.loadingOverlayState = payload
    },
    setAATestMetricResults: (state, { payload }: PayloadAction<AATestMetricResultType[]>) => {
      state.aaTest.metricResults = payload
    },
  },
})

export const {
  resetState,
  setIsLoading,
  setExperimentType,
  setAATestEnabled,
  setAATestMetrics,
  setAATestMetricForm,
  setAATestLoadingOverlayState,
  setAATestMetricResults,
} = slice.actions
export default slice.reducer
